import { userService, franquiciaService } from "@/_services";

const SESSION_STORAGE_KEYS = [
  "user",
  "franquicia",
  // Ya no se usa (agrupación de clientes eliminada); se borra para limpiar sesiones antiguas
  "agrupacionClienteSelected",
  "empleado",
  "roles-menu",
];

function getInitialSession() {
  const user = JSON.parse(localStorage.getItem("user"));
  return {
    user,
    token: user && (user.accessToken || user.token),
  };
}

function persistSession(session) {
  SESSION_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
  localStorage.setItem("user", JSON.stringify(session.user));

  [
    ["franquicia", session.franquicia],
    ["empleado", session.empleado],
    ["roles-menu", session.rolesMenu],
  ].forEach(([key, value]) => {
    if (value) localStorage.setItem(key, value);
  });
}

const initialSession = getInitialSession();

export const user = {
  namespaced: true,
  state: {
    session: initialSession,
    entity: {
      data: initialSession.user || {},
      status: initialSession.user ? { logged: true } : {},
    },
    editPass: {
      data: {},
      status: {},
    },
    oneShotToken: {
      data: {},
      status: {},
    },
    list: {
      data: [],
      status: {},
    },
    users: {
      data: [],
      status: {},
    },
    roles: {
      data: [],
      status: {},
    },
    nuevoUsuario: {
      data: [],
      status: {},
    },
    changeStateUser: {
      data: [],
      status: {},
    },
    enlace: {
      data: [],
      status: {},
    },
    reset: {
      data: [],
      status: {},
    },
    getEntity: {
      data: [],
      status: {},
    },
    update: {
      data: [],
      status: {},
    },
  },
  mutations: {
    persistSession(state, session) {
      persistSession(session);
      state.session = {
        user: session.user,
        token: session.token || (session.user && (session.user.accessToken || session.user.token)),
      };
    },
    setSession(state, session) {
      persistSession(session);
      const token = session.token || (session.user && (session.user.accessToken || session.user.token));
      state.session = { user: session.user, token };
      state.entity.data = session.user;
      state.entity.status = { logged: true };
    },
    updateSessionContext(state, context) {
      const user = JSON.parse(JSON.stringify(state.session.user));
      if (context.franquiciaId !== undefined) {
        user.extraData.franquiciaId = context.franquiciaId;
      }

      localStorage.setItem("user", JSON.stringify(user));
      if (context.franquicia !== undefined) {
        if (context.franquicia) localStorage.setItem("franquicia", context.franquicia);
        else localStorage.removeItem("franquicia");
      }

      state.session.user = user;
      state.entity.data = user;
    },
    clearSession(state) {
      SESSION_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
      state.session = { user: null, token: null };
      state.entity.data = {};
      state.entity.status = {};
    },
    newUsuarioRequest(state) {
      state.nuevoUsuario.status = {
        creating: true,
      };
    },
    newUsuarioError(state, error) {
      state.nuevoUsuario.data = null;
      state.nuevoUsuario.status = {
        error,
      };
    },
    newUsuarioSuccess(state, envio) {
      state.nuevoUsuario.data = envio;
      state.nuevoUsuario.status = {
        created: true,
      };
    },

    changeStateUsuarioRequest(state) {
      state.changeStateUser.status = {
        loading: true,
      };
    },
    changeStateUsuarioError(state, error) {
      state.changeStateUser.data = null;
      state.changeStateUser.status = {
        error,
      };
    },
    changeStateUsuarioSuccess(state, envio) {
      state.changeStateUser.data = envio;
      state.changeStateUser.status = {
        loaded: true,
      };
    },
    getUserByIdRequest(state) {
      state.getEntity.status = {
        loading: true,
      };
    },
    getUserByIdError(state, error) {
      state.getEntity.data = null;
      state.getEntity.status = {
        error,
      };
    },
    getUserByIdSuccess(state, envio) {
      state.getEntity.data = envio;
      state.getEntity.status = {
        loaded: true,
      };
    },
    updateUserRequest(state) {
      state.update.status = {
        updating: true,
      };
    },
    updateUserError(state, error) {
      state.update.data = null;
      state.update.status = {
        error,
      };
    },
    updateUserSuccess(state, envio) {
      state.update.data = envio;
      state.update.status = {
        updated: true,
      };
    },

    loginUserRequest(state) {
      state.entity.status = {
        logging: true,
      };
    },
    loginUserError(state, error) {
      state.entity.data = {};
      state.entity.status = {
        error,
      };
    },
    loginUserSuccess(state, usuario) {
      state.entity.data = usuario;
      state.entity.status = {
        logged: true,
      };
    },

    changePasswordRequest(state) {
      state.editPass.status = {
        editing: true,
      };
    },
    changePasswordError(state, error) {
      state.editPass.data = {};
      state.editPass.status = {
        error,
      };
    },
    changePasswordSuccess(state, usuario) {
      state.editPass.data = usuario;
      state.editPass.status = {
        edited: true,
      };
    },

    oneShotTokenRequest(state) {
      state.oneShotToken.data = null;
      state.oneShotToken.status = {
        loaded: false,
      };
    },
    oneShotTokenError(state, error) {
      state.oneShotToken.data = null;
      state.oneShotToken.status = {
        loaded: true,
        error: error,
      };
    },
    oneShotTokenSuccess(state, token) {
      state.oneShotToken.data = token;
      state.oneShotToken.status = {
        loaded: true,
      };
    },

    getUsuariosRequest(state) {
      state.list.status = {
        lading: true,
      };
    },
    getUsuariosError(state, error) {
      state.list.data = {};
      state.list.status = {
        error,
      };
    },
    getUsuariosSuccess(state, usuario) {
      state.list.data = usuario;
      state.list.status = {
        loaded: true,
      };
    },

    getUsersFranquiciaRequest(state) {
      state.users.status = {
        loading: true,
      };
    },
    getUsersFranquiciaError(state, error) {
      state.users.data = {};
      state.users.status = {
        error,
      };
    },
    getUsersFranquiciaSuccess(state, usuario) {
      state.users.data = usuario;
      state.users.status = {
        loaded: true,
      };
    },

    getRolesRequest(state) {
      state.roles.status = {
        loading: true,
      };
    },
    getRolesError(state, error) {
      state.roles.data = {};
      state.roles.status = {
        error,
      };
    },
    getRolesSuccess(state, usuario) {
      state.roles.data = usuario;
      state.roles.status = {
        loaded: true,
      };
    },

    getEnlaceRequest(state) {
      state.enlace.status = {
        getting: true,
      };
    },
    getEnlaceError(state, error) {
      state.enlace.data = {};
      state.enlace.status = {
        error,
      };
    },
    getEnlaceSuccess(state, user) {
      state.enlace.data = user;
      state.enlace.status = {
        getted: true,
      };
    },

    resetPasswordRequest(state) {
      state.reset.status = {
        resetting: true,
      };
    },
    resetPasswordError(state, error) {
      state.reset.data = {};
      state.reset.status = {
        error,
      };
    },
    resetPasswordSuccess(state, user) {
      state.reset.data = user;
      state.reset.status = {
        reseted: true,
      };
    },
  },

  actions: {
    persistSession({ commit }, { user, token, ...session } = {}) {
      commit("persistSession", {
        user,
        token: token || (user && (user.accessToken || user.token)),
        ...session,
      });
    },
    setSession({ commit, dispatch }, { user, token, broadcast = true, ...session } = {}) {
      dispatch("dashboard/resetNotifications", null, { root: true });
      const normalizedSession = {
        user,
        token: token || (user && (user.accessToken || user.token)),
        broadcast,
        ...session,
      };
      commit("setSession", normalizedSession);
    },
    updateSessionContext({ commit, dispatch }, { broadcast = true, ...context } = {}) {
      dispatch("dashboard/resetNotifications", null, { root: true });
      commit("updateSessionContext", { ...context, broadcast });
    },
    clearSession({ commit, dispatch }, { broadcast = true } = {}) {
      dispatch("dashboard/resetNotifications", null, { root: true });
      commit("clearSession", { broadcast });
    },
    login({ commit, dispatch }, req) {
      commit("loginUserRequest");
      return userService
        .login(req.user, req.password)
        .then((res) => {
          if (res.roles.includes("FRANQUICIA")) {
            dispatch("persistSession", { user: res });
            return franquiciaService
              .loadFranquicia()
              .then((franquicia) => {
                dispatch("setSession", { user: res, franquicia: JSON.stringify(franquicia) });
                return res;
              });
          } else {
            commit("loginUserError", new Error("Acceso Denegado"));
          }
        })
        .catch((error) => {
          commit("loginUserError", error);
        });
    },
    changePassword({ commit }, body) {
      commit("changePasswordRequest");
      userService
        .changePassword(body)
        .then((res) => {
          commit("changePasswordSuccess", res);
        })
        .catch((error) => {
          commit("changePasswordError", error);
        });
    },
    oneShotToken({ commit }, body) {
      commit("oneShotTokenRequest");
      userService
        .oneShotToken(body)
        .then((res) => {
          commit("oneShotTokenSuccess", res["token"]);
        })
        .catch((error) => {
          commit("oneShotTokenError", error);
        });
    },
    getUsuarios({ commit }, req) {
      commit("getUsuariosRequest");
      userService
        .getUsuarios(req.filters, req.pagination)
        .then((usuarios) => {
          commit("getUsuariosSuccess", usuarios);
        })
        .catch((error) => {
          commit("getUsuariosError", error);
        });
    },
    usersFranquicia({ commit }, req) {
      commit("getUsersFranquiciaRequest");
      userService
        .usersFranquicia(req.id, req.filters, req.pagination, req.tipo)
        .then((users) => {
          commit("getUsersFranquiciaSuccess", users);
        })
        .catch((error) => {
          commit("getUsersFranquiciaError", error);
        });
    },
    getRoles({ commit }, roles) {
      commit("getRolesRequest");
      userService
        .getRoles(roles)
        .then((rols) => {
          commit("getRolesSuccess", rols);
        })
        .catch((error) => {
          commit("getRolesError", error);
        });
    },
    nuevoUsuario({ commit }, req) {
      commit("newUsuarioRequest");
      userService
        .nuevoUsuario(req.tipo, req.id, req.user)
        .then((env) => {
          commit("newUsuarioSuccess", env);
        })
        .catch((error) => {
          commit("newUsuarioError", error);
        });
    },
    cambiarEstadoUser({ commit }, user) {
      commit("changeStateUsuarioRequest");
      userService
        .cambiarEstadoUser(user)
        .then((usuario) => {
          commit("changeStateUsuarioSuccess", usuario);
        })
        .catch((error) => {
          commit("changeStateUsuarioError", error);
        });
    },
    getUserById({ commit }, user) {
      commit("getUserByIdRequest");
      userService
        .getUserById(user)
        .then((usuario) => {
          commit("getUserByIdSuccess", usuario);
        })
        .catch((error) => {
          commit("getUserByIdError", error);
        });
    },
    updateUser({ commit }, req) {
      commit("updateUserRequest");
      userService
        .updateUser(req.id, req.body)
        .then((usuario) => {
          commit("updateUserSuccess", usuario);
        })
        .catch((error) => {
          commit("updateUserError", error);
        });
    },
    getEnlaceRecuperacion({ commit }, body) {
      commit("getEnlaceRequest");
      userService
        .getEnlaceRecuperacion(body)
        .then((user) => {
          commit("getEnlaceSuccess", user);
        })
        .catch((error) => {
          commit("getEnlaceError", error);
        });
    },
    resetLogin({ commit }, request) {
      commit("resetPasswordRequest");
      userService
        .resetPassword(request.body, request.token)
        .then((user) => {
          commit("resetPasswordSuccess", user);
        })
        .catch((error) => {
          commit("resetPasswordError", error);
        });
    },
  },
};
